module.exports = __webpack_public_path__ + "img/rq.ed69f6b5.png";